import { configureStore } from '@reduxjs/toolkit';
import { ShopSettings, WishlistSettings, OverlaySettings } from './reducers';

export const store = configureStore({
  reducer: {
    WishlistSettings,
    ShopSettings,
    OverlaySettings
  }
})